import { useState } from "react";
import close from "../../asset-source/close.svg";
import logoW from "../../asset-source/logo-w.svg";
import { useLocation, useNavigate } from "react-router-dom";

const ContactUsModal = ({}) => {
	const [currentField, setCurrentField] = useState("");
	const [nameUser, setNameUser] = useState("");
	const [contacts, setContact] = useState("");
	const [textfield, setTextfield] = useState("");
	const [time, setTime] = useState("1 мес");
	const [budget, setBudget] = useState(3);

	const navigate = useNavigate();
	const { location, search } = useLocation();

	function functionname() {
		var ajax = new XMLHttpRequest();
		// var data = document.getElementById("form");
		// var formdata = new FormData(data);
		var formdata = new FormData();
		formdata.append("fname", nameUser);
		formdata.append("email", contacts);
		formdata.append("info", textfield);
		// formdata.append("source", listId);
		// formdata.append("not_doi", 1);

		var object = {};
		formdata.forEach(function (value, key) {
			object[key] = value;
		});
		var json = JSON.stringify(object);

		ajax.open("POST", `https://wjet.io/api/telegram/log`, true);
		ajax.setRequestHeader("Content-Type", "application/json; charset=UTF-8");
		// ajax.setRequestHeader("Access-Control-Allow-Origin", "*");

		ajax.send(json);

		window.gtag("event", "conversion", {
			send_to: "AW-16987029684/2ZrnCL-L3bUaELSBhqQ_",
		});

		handleClose();
	}

	function handleClose() {
		setCurrentField("");
		navigate(location);
		// onClose();
	}

	if (!search.includes("modal")) {
		return;
	}

	return (
		<div className="modal">
			<div
				className="modal__layer"
				onClick={handleClose}
			/>
			<form
				action=""
				className="modal__body"
				id="form"
				method="post"
				onSubmit={(e) => {
					e.preventDefault();
					setCurrentField("");
					functionname();
					setNameUser("");
					setContact("");
					setTextfield("");
				}}
				// onSubmit={handleClose}
				// target="_blank"
			>
				<button
					className="btn close hide--mobile"
					onClick={handleClose}
				>
					<img
						src={close}
						alt=""
					/>
				</button>

				<div className="modal__title">
					Расскажите о вашем проекте
					<button
						className="btn close close--mobile"
						onClick={handleClose}
					>
						<img
							src={close}
							alt=""
						/>
					</button>
				</div>

				<div className="modal__form">
					<div className={currentField === "name" ? "focused field" : "field"}>
						Как вас зовут
						<input
							name="fname"
							type="text"
							className="input"
							placeholder="ФИО"
							id="mce-FNAME"
							// name="name"
							onClick={(e) => {
								e.stopPropagation();
								setCurrentField("name");
							}}
							onInput={(e) => {
								setNameUser(e.target.value);
							}}
							required
							value={nameUser}
						/>
					</div>
					<div
						className={currentField === "contact" ? "focused field" : "field"}
					>
						Как с вами связаться
						<input
							name="email"
							id="mce-EMAIL"
							type="text"
							className="input"
							placeholder="Почта"
							onClick={(e) => {
								e.stopPropagation();
								setCurrentField("contact");
							}}
							onInput={(e) => {
								setContact(e.target.value);
							}}
							required
							value={contacts}
						/>
					</div>
				</div>

				<div className="modal__form">
					<div className={currentField === "idea" ? "focused field" : "field"}>
						Опишите ваш проект
						<textarea
							name="info"
							id="mce-INFO"
							type="text"
							className="input textfield"
							placeholder="Общее представление о проекте, тематике и задачах"
							value={textfield}
							onInput={(e) => {
								setTextfield(e.target.value);
							}}
							onClick={(e) => {
								e.stopPropagation();
								setCurrentField("idea");
							}}
						></textarea>
					</div>
					<div className="times">
						<div className="question">Сроки, месяцев</div>
						<div className="question__row">
							<div
								className={
									time === "до 1 мес"
										? "active question__item"
										: "question__item"
								}
								onClick={() => {
									setTime("до 1 мес");
								}}
							>
								&#8595; 1
							</div>
							<div
								className={
									time === "1–3 мес"
										? "active question__item"
										: "question__item"
								}
								onClick={() => {
									setTime("1–3 мес");
								}}
							>
								1–3
							</div>
							<div
								className={
									time === "3-6 мес"
										? "active question__item"
										: "question__item"
								}
								onClick={() => {
									setTime("3-6 мес");
								}}
							>
								3–6
							</div>
							<div
								className={
									time === "12 мес" ? "active question__item" : "question__item"
								}
								onClick={() => {
									setTime("12 мес");
								}}
							>
								&#8593; 12
							</div>
						</div>

						<div className="question">Бюджет, &#8381; </div>
						<div className="question__row">
							<div
								className={
									budget === "до 1" ? "active question__item" : "question__item"
								}
								onClick={() => {
									setBudget("до 1");
								}}
							>
								&#8595; 1 млн.
							</div>
							<div
								className={
									budget === "1-3" ? "active question__item" : "question__item"
								}
								onClick={() => {
									setBudget("1-3");
								}}
							>
								1–3 млн.
							</div>
							<div
								className={
									budget === "более 3"
										? "active question__item"
										: "question__item"
								}
								onClick={() => {
									setBudget("более 3");
								}}
							>
								&#8593; 3 млн.
							</div>
						</div>
					</div>
				</div>

				<div className="modal__form">
					<input
						type="hidden"
						name="tags"
						value="36783"
					/>

					<button
						className="btn action"
						type="submit"
					>
						Отправить заявку
					</button>
					<div className="modal__policy">
						<div>
							Отправляя заявку вы соглашаетесь
							на&nbsp;обработку&nbsp;персональных данных
						</div>
						<img
							src={logoW}
							alt=""
							className="logo"
						/>
					</div>
				</div>
			</form>
		</div>
	);
};

export default ContactUsModal;
